export enum Variants {
  Body2 = 'body2',
  H5 = 'h5',
  Subtitle1 = 'subtitle1',
}
